import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DialogService} from "@progress/kendo-angular-dialog";
import {DtoBranchUserDetailed} from "./models/DtoBranchUserDetailed";
import {BranchesListService} from "./branches-list.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";


@Component({
    selector: 'app-branches-list',
    template: require('./branches-list.component.html'),
    styles: [require('./branches-list.component.css')]
})

@AutoUnsubscribe()
export class BranchesListComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    pageHeaderConfig: PageHeaderBarConfig = {
        title: 'VESTIGINGEN',
        buttonDefinition: [
            {
                description: 'INLOGGEN',
                isSmall: false,
                clickEventType: 'login'
            }
        ]
    };

    data: DtoBranchUserDetailed[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'companyName',
            label: 'Vestiging',
            type: 'string',
            width: '*'
        },
        {
            key: 'username',
            label: 'Gebruikersnaam',
            type: 'string',
            width: '150px'
        },
        {
            key: 'city',
            label: 'Plaats',
            type: 'string',
            width: '200px'
        },
        {
            key: 'phoneNo',
            label: 'Telefoonnummer',
            type: 'string',
            width: '150px'
        },
        {
            key: 'email',
            label: 'Email',
            type: 'string',
            width: '200px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private dialogService: DialogService,
                private ds: BranchesListService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'vestigingen', isLastStep: false },
            { text: 'overzicht', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        setTimeout(() => {
            this.loadData();
        });
    }

    loadData() {
        this.ds.getBranchesDetailed().subscribe((res: DtoBranchUserDetailed[]) => {
            this.data = res;
            this.grid.showData(this.data);
        });
    }

    phbBtnClicked(event) {
        if (event == 'login') {
            if (this.grid.getSelectedId() > 0) {
                this.loginWithOtp( this.grid.getSelectedItem());
            }
        }
    }

    gridRowdoubleClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.loginWithOtp( this.grid.getSelectedItem());
        }
    }

    loginWithOtp(branch: DtoBranchUserDetailed) {
        this.ds.createBranchOtp(branch.id).subscribe((res: string) => {
            let url = `https://ngapp.mijnsalon.nl?username=${branch.username}&otp=${res}`;
            window.open(url);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/branches/branches-list/branches-list.component.ts